<div class="map" #map id="map" (dblclick)="setMarkerMouseEvent($event)"></div>